import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VTooltip,{attrs:{"top":"","open-delay":"300"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('div',_vm._g(_vm._b({staticClass:"back-button",class:{ 'disabled': _vm.disabled, ..._vm.btnClass },style:({
				background: _vm.backgroundColor,
			}),on:{"click":function($event){!_vm.disabled && _vm.$emit('click')}}},'div',attrs,false),on),[_c(VIcon,{staticStyle:{"color":"var(--grey-400)"}},[_vm._v("mdi-arrow-left-thin")])],1)]}}])},[_c('div',[_vm._v(" "+_vm._s(_vm.tooltipText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }